export interface NewsCategory {
  slug: string;
  name: string;
  tagline: string;
  icon: string;
}

export const newsCategories: NewsCategory[] = [
  { slug: "yule", name: "娱乐", tagline: "明星动态与圈内热点", icon: "ri-mic-line" },
  { slug: "shehui", name: "社会", tagline: "身边大事与民生关切", icon: "ri-community-line" },
  { slug: "keji", name: "科技", tagline: "新产品与数字生活", icon: "ri-cpu-line" },
  { slug: "caijing", name: "财经", tagline: "市场脉搏与消费趋势", icon: "ri-bank-card-line" },
  { slug: "tiyu", name: "体育", tagline: "赛场动态与健儿风采", icon: "ri-basketball-line" },
];